export const isObjectEmpty = (obj: unknown = {}): boolean | unknown => {
  if (typeof obj === 'object' && obj !== null) {
    return Object.entries(obj).length === 0 && obj.constructor === Object;
  }
  return {};
};
